import { setBrowserMode } from '@/reducers/menus';
import { setUID, setUserData } from '@/reducers/users';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { yixiaoMessage } from './utils';
import { setLocalStorageExpire } from './utils/cookie-tool';
import axios from '@/api/ai-axios';
import useAuth from '@/hooks/useAuth';

const YIXIAOHOC = (WrappedComponent) => {
  const SimpleComponent = (props) => {
    const { userData, uid } = props;

    const prevProps = useRef();
    const { checkLogin } = useAuth();

    useEffect(() => {
      if (window.cFunNotifyAiWebLoadOver) {
        // 通知一校客户端加载完毕
        window.cFunNotifyAiWebLoadOver('');
        window.notifyAiWebAccount = yixiaoLogin;
      }
    }, []);

    useEffect(() => {
      if (
        prevProps.current?.quotaInfo?.total_balance !==
          userData?.quotaInfo?.total_balance &&
        userData?.quotaInfo?.total_balance !== undefined
      ) {
        if (window.cFunNotifyAiScoreChange) {
          // 剩余积分 差值
          let diffScore =
            userData?.quotaInfo?.total_balance -
              prevProps.current?.quotaInfo?.total_balance || 0;
          const scoreChange = {
            score: userData?.quotaInfo?.total_balance,
            use: diffScore,
            uid: uid,
          };
          window.cFunNotifyAiScoreChange(`${JSON.stringify(scoreChange)}`);
        }
      }

      prevProps.current = userData;
    }, [userData, uid]);

    const yixiaoLogin = (params) => {
      try {
        const { account, password } = JSON.parse(params);
        if (!account || !password) {
          throw new Error('缺少参数,请检查账号和密码是否正确！');
        }

        axios
          .post('/api/yixiao/login', {
            account,
            password,
          })
          .then((data) => {
            if (data.status == 1) {
              checkLogin();
              props.handleSetUserData(data.data);
              props.handleSetUid(data.data.uid);
              let expiresTime = 60 * 24 * 30; // cookie过期时间, 单位：分钟
              setLocalStorageExpire('uid', data.data.uid, expiresTime);
            } else {
              yixiaoMessage(data.message);
            }
          })
          .catch((err) => {
            yixiaoMessage(`登录失败,${err.message}`);
          });
      } catch (err) {
        console.log(err);
        yixiaoMessage(`登录失败,${err.message}`);
      }
    };

    return <WrappedComponent {...props} />;
  };
  const mapStateToProps = (state) => ({
    browserMode: state.menus.browserMode,
    userData: state.users.data,
    uid: state.users.uid,
  });

  const mapDispatchToProps = (dispatch) => ({
    handleSetBrowserMode: (mode) => dispatch(setBrowserMode(mode)),
    handleSetUserData: (data) => dispatch(setUserData(data)),
    handleSetUid: (data) => dispatch(setUID(data)),
  });

  return connect(mapStateToProps, mapDispatchToProps)(SimpleComponent);
};

export default YIXIAOHOC;
